import React, { useState,useEffect } from 'react';
import Tabs from '../../../../Components/Tabs';
import ManageNatureOfExpenseScreen from '../../../../ExpenseManagement/View/ManageNatureOfExpenseScreen';
import LeaveConfigurationScreen from '../../../../LeaveManagement/View/LeaveConfigurationScreen';
import EmpMgmtSettingsController from '../../../Controllers/AdminScreens/Users/EmpMgmtSettingsController';
import ExpenseOpeningBalanceScreen from '../../../../ExpenseManagement/View/ExpenseOpeningBalanceScreen';

const EmpMgmtSettingsSereen = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [disabledTabs, setDisabledTabs] = useState([]);
  const{
    leaveConfigurationListError,
    leaveConfigurationListLoading,
    leaveConfigurationsList,
    handleGetLeaveConfiguration,
    expenseOpeningInfo,
    expenseOpeningInfoLoading,
    expenseOpeningInfoError,
    onExpenseOpeningInfoRefresh
  } = EmpMgmtSettingsController()

  const handleTabChange = (index) => {
    if (disabledTabs.includes(index)) return;
    setSelectedTab(index);
  };

      useEffect(() => {
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
          const { per_name_sub_json } = storedUserInfo?.user_permissions?.emp_mgmt_settings || {};
          const tabPermissions = [
            { name: "Leave Configuration", key: "leave_config"},
            { name: "Manage Nature of Expense", key: "manage_nature_expense"},
            { name: "Expense Management Opening Balance", key: "exp_mgmt_open_bal"}
          ]
          const disabledTabIndices = tabPermissions
              .map((tab, index) => (per_name_sub_json[tab?.key] !== 1 ? index : null))
              .filter(index => index !== null);
          console.log('disabledTabIndices :',disabledTabIndices)
          setDisabledTabs(disabledTabIndices)
          if (disabledTabIndices.includes(selectedTab)) {
            const firstEnabledTab = tabPermissions.findIndex((_, index) => !disabledTabIndices.includes(index))
            setSelectedTab(firstEnabledTab !== -1 ? firstEnabledTab : 0)
          }
      }, [selectedTab]);

  return (
    <div style={styles.mainContent}>
      <div className='title-container' style={{ paddingBottom: 10 }}>
        <h2 className='title'>Emp. Mgmt - Settings</h2>
      </div>

      <Tabs
        tabs={[
          'Leave Configuration',
          'Manage Nature of Expense',
          'Expense Management Opening Balance'
        ]}
        selectedIndex={selectedTab}
        onTabChange={handleTabChange}
        disabledTabs={disabledTabs}
      >
        {selectedTab === 0 && !disabledTabs.includes(0) && <LeaveConfigurationScreen leaveConfigurationsList={leaveConfigurationsList} leaveConfigurationListLoading={leaveConfigurationListLoading} leaveConfigurationListError={leaveConfigurationListError} onRefresh={handleGetLeaveConfiguration}/>}
        {selectedTab === 1 && !disabledTabs.includes(1) && <ManageNatureOfExpenseScreen />}
        {selectedTab === 2 && !disabledTabs.includes(2) && <ExpenseOpeningBalanceScreen expenseOpeningInfo={expenseOpeningInfo} expenseOpeningInfoLoading={expenseOpeningInfoLoading} expenseOpeningInfoError={expenseOpeningInfoError} onRefresh={onExpenseOpeningInfoRefresh} />}
      </Tabs>
    </div>
  );
};

const styles = {
  mainContent: {
    width: '95%',
    margin: 'auto',
  },
};

export default EmpMgmtSettingsSereen;
